import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

export default function AdminLogin() {
  const { signIn, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (isAuthenticated) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await signIn(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(
        err.message === "Invalid login credentials"
          ? "Email atau password salah."
          : err.message || "Gagal masuk. Silakan coba lagi."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      height: "100vh", background: "#f1f5f9", fontFamily: "system-ui,sans-serif",
    }}>
      <form onSubmit={handleSubmit} style={{
        width: 360, background: "#fff", borderRadius: 14, padding: "32px 28px",
        boxShadow: "0 8px 30px rgba(15,23,42,0.08)", border: "1px solid #e2e8f0",
      }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: "#0f172a", marginBottom: 4 }}>
          Admin Login
        </div>
        <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 24 }}>
          MLV Teknologi RoomDesigner 3D
        </div>

        <label style={{ fontSize: 12, fontWeight: 600, color: "#475569", display: "block", marginBottom: 6 }}>
          Email
        </label>
        <input
          type="email"
          required
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            width: "100%", padding: "10px 12px", borderRadius: 8,
            border: "1px solid #cbd5e1", fontSize: 14, marginBottom: 16,
            outline: "none", boxSizing: "border-box",
          }}
          placeholder="admin@email.com"
        />

        <label style={{ fontSize: 12, fontWeight: 600, color: "#475569", display: "block", marginBottom: 6 }}>
          Password
        </label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            width: "100%", padding: "10px 12px", borderRadius: 8,
            border: "1px solid #cbd5e1", fontSize: 14, marginBottom: 16,
            outline: "none", boxSizing: "border-box",
          }}
          placeholder="••••••••"
        />

        {error && (
          <div style={{
            background: "#fef2f2", border: "1px solid #fecaca", color: "#dc2626",
            fontSize: 12, padding: "8px 12px", borderRadius: 8, marginBottom: 16,
          }}>
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%", padding: "11px", borderRadius: 8, border: "none",
            background: loading ? "#93c5fd" : "#3b82f6", color: "#fff",
            fontSize: 14, fontWeight: 600, cursor: loading ? "default" : "pointer",
          }}
        >
          {loading ? "Memproses..." : "Masuk"}
        </button>
      </form>
    </div>
  );
}
